import * as React from 'react'

function SmileyIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 18.667a4 4 0 11-8 0h8z"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 4C9.383 4 4 9.383 4 16s5.383 12 12 12 12-5.384 12-12S22.616 4 16 4zM10.667 12.667H12M21.333 12.667H20"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { SmileyIcon }
